import {
	hideDialog,
	showDialog,
	setPerspective,
	selectPart,
	deselectPart,
	addVehicleOverview,
	selectSetup,
	applySetup,
	applyParts,
	removeAllParts,
	showToast,
	hideToast,
	ShowDialogProps,
	setImageTimestamp,
	addCreatedConfiguration,
	addPrice,
	setConfigurationId,
	setConfigurationImages,
	togglePartDetail,
	toggleSummary
} from "../redux/actions";

import {
	getAllSetups,
	getDialogState,
	getSelectedModel,
	getCategories,
	getSelectedPart,
	getPerspective,
	getAppliedSetup,
	getSelectedSetup,
	getAllParts,
	getAppliedParts,
	getToastState,
	getMotorcycleModels,
	getConfiguration,
	getPrice,
	getImageTimeStamp,
	getOverview,
	getViews,
	getConfigurationWasRecentlyCreatedSelector
} from "../redux/selectors";
import { Setup } from "../components/setups/SetupsList";
import Action from "../redux/reducers/models/action";
import { DialogState } from "../redux/reducers/modals";
import {
	VehicleInformation,
	MotorcycleModelResponse,
	Price
} from "../components/main/motorcycles/MotorcycleView";
import { Part } from "../components/parts/PartsList";
import { Store as AppStore } from "../redux/reducers";
import { ToastMessageState } from "../redux/reducers/toast";
import { VehicleOverviewState } from "../redux/reducers/vehicleOverview";
import {
	CreateConfigurationResponse,
	FullImage
} from "../components/configuration/ConfigurationView";
import { ViewsState } from "../redux/reducers/views";

export interface StateToProps {
	setups: Setup[];
	models: MotorcycleModelResponse;
	parts: Part[];
	dialogState: DialogState;
	perspective: number;
	selectedModel: VehicleInformation;
	categories: string[];
	selectedPart: Part;
	appliedSetup: Setup | undefined;
	selectedSetup: Setup;
	appliedParts: Part[];
	toast: ToastMessageState;
	configuration: CreateConfigurationResponse;
	totalPrice: Price;
	wasRecentlyCreated: boolean;
	imageTimestamp: number;
	overview: VehicleOverviewState;
	views: ViewsState;
}

export interface DispatchToProps {
	addVehicleOverview: (payload: VehicleOverviewState) => Action;
	showDialog: (dialogProps: ShowDialogProps) => Action;
	hideDialog: () => Action;
	setPerspective: (perspective: number) => Action;
	selectSetup: (payload: Setup) => Action;
	applySetup: (payload: Setup) => Action;
	selectPart: (part: Part) => Action;
	deselectPart: () => Action;
	removeAllParts: () => Action;
	applyParts: (payload: string[]) => Action;
	showToast: (payload: string) => Action;
	hideToast: () => Action;
	addCreatedConfiguration: (config: CreateConfigurationResponse) => Action;
	addPrice: (price: Price) => Action;
	setImageTimestamp: () => Action;
	setConfigurationId: (configId: number) => Action;
	setConfigurationImages: (images: FullImage[]) => Action;
	togglePartDetail: (show: boolean) => Action;
	toggleSummary: (show: boolean) => Action;
}

export type StateManagementProps = StateToProps & DispatchToProps;

export const mapStateToProps = (store: AppStore): StateToProps => {
	return {
		setups: getAllSetups(store),
		parts: getAllParts(store),
		appliedParts: getAppliedParts(store),
		dialogState: getDialogState(store),
		models: getMotorcycleModels(store),
		perspective: getPerspective(store),
		selectedModel: getSelectedModel(store),
		categories: getCategories(store),
		selectedPart: getSelectedPart(store),
		appliedSetup: getAppliedSetup(store),
		selectedSetup: getSelectedSetup(store),
		toast: getToastState(store),
		configuration: getConfiguration(store),
		totalPrice: getPrice(store),
		wasRecentlyCreated: getConfigurationWasRecentlyCreatedSelector(store),
		imageTimestamp: getImageTimeStamp(store),
		overview: getOverview(store),
		views: getViews(store)
	};
};

export const mapDispatchToProps: DispatchToProps = {
	addVehicleOverview,
	hideDialog,
	showDialog,
	setPerspective,
	selectPart,
	deselectPart,
	selectSetup,
	applySetup,
	applyParts,
	showToast,
	hideToast,
	removeAllParts,
	addCreatedConfiguration,
	addPrice,
	setImageTimestamp,
	setConfigurationId,
	setConfigurationImages,
	togglePartDetail,
	toggleSummary
};
